// card-overlay
import find from 'lodash/find';
import { useRouter } from 'next/router';
import React from 'react';
import CardOverlay from 'src/components/cards/card-overlay';
import CardV from 'src/components/cards/card-v';
import Carousels from 'src/components/carousels';
import { DATALAYER_TYPE } from 'src/utils/datalayer/send-datalayer';
import styled from 'styled-components';

function SectionFive({ dataSet, data }: any) {
  const router = useRouter();
  return (
    <SectionWrapper className='section-5'>
      <div className='title-text'>{find(dataSet, { key: 'title-text' })?.value}</div>
      <div className=' container'>
        <div className='card-wrapper'>
          {data.slice(0, 1).map((item: any, index: number) => (
            <CardOverlay
              key={index}
              data={item}
              showTitle={true}
              showBlurb={false}
              showByline={false}
              showTime={false}
              external={false}
              //! DATALAYER
              eventDataLayer={{
                type: DATALAYER_TYPE.TRACK_INDEX,
                router: router?.pathname,
                section: 'section-chaliang-5',
                data: {
                  title: item?.title,
                  heading: item?.subCategory?.en,
                  index: 1
                }
              }}
            />
          ))}
          {data.slice(1, 4).map((item: any, index: number) => (
            <CardV
              key={index}
              data={item}
              showTitle={true}
              showBlurb={false}
              showByline={false}
              showTime={false}
              showCountview={false}
              external={false}
              //! DATALAYER
              eventDataLayer={{
                type: DATALAYER_TYPE.TRACK_INDEX,
                router: router?.pathname,
                section: 'section-chaliang-5',
                data: {
                  title: item?.title,
                  heading: item?.subCategory?.en,
                  index: index + 2
                }
              }}
            />
          ))}
        </div>
        <div className='card-wrapper-mb'>
          <Carousels slideShow={1} dots={true}>
            {data.slice(0, 4).map((item: any, index: number) => (
              <CardOverlay
                key={index}
                data={item}
                showTitle={true}
                showBlurb={false}
                showByline={false}
                showTime={false}
                external={false}
                //! DATALAYER
                eventDataLayer={{
                  type: DATALAYER_TYPE.TRACK_INDEX,
                  router: router?.pathname,
                  section: 'section-chaliang-5-mb',
                  data: {
                    title: item?.title,
                    heading: item?.subCategory?.en,
                    index: index + 1
                  }
                }}
              />
            ))}
          </Carousels>
        </div>
        <a className='view-more' href={`tags/${find(dataSet, { key: 'tag' })?.value}`}>
          <p>ดูทั้งหมด</p>
        </a>
      </div>
    </SectionWrapper>
  );
}
const SectionWrapper = styled.div`
  position: relative;
  width: 100%;
  padding: 40px 20px 80px 20px;
  background-color: #6b64a0;
  @media (max-width: 767px) {
    padding: 60px 20px 50px 20px;
  }
  .container {
    background-color: #fff;
  }
  .title-text {
    font-size: 58px;
    font-weight: bolder;
    letter-spacing: 0px;
    color: #fff;
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    text-shadow: 0px 1px, 1px 0px, 1px 1px;
    cursor: context-menu;

    @media (max-width: 475px) {
      font-size: 34px;
    }
  }
  .card-wrapper {
    position: relative;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    gap: 0 20px;
    @media (max-width: 767px) {
      display: none;
    }
    .card-overlay {
      width: 100%;
    }
    .card-v {
      width: 31%;
      @media (max-width: 475px) {
        width: 48%;
      }
    }
  }
  .card-wrapper-mb {
    position: relative;
    width: 100%;
    display: none;
    @media (max-width: 767px) {
      display: block;
    }
    .carousel {
      padding-bottom: 50px;
    }
    .card-overlay {
      width: 100%;
    }
  }
  .view-more {
    cursor: pointer;
    display: flex;
    justify-content: flex-end;
    padding-bottom: 12px;
    p {
      bottom: 20px;
      right: 20px;
      padding: 2px 20px;
      background-color: rgb(220 21 53);
      color: #fff;
      border-radius: 8px;
      &:hover {
        color: #ed1a3b;
        background-color: rgb(255, 255, 255);
      }
    }
  }
`;
export default SectionFive;
